module.exports = __webpack_public_path__ + "img/login2.9a3d1148.png";